import type { Locale } from '@/types';
import { en } from './locales/en';
import { kz } from './locales/kz';
import { ru } from './locales/ru';

export type { TranslationKey } from './locales/ru';

export const dictionaries = { kz, ru, en } as const;

export const locales: readonly Locale[] = ['kz', 'ru', 'en'];

export const defaultLocale: Locale = 'ru';

export const isLocale = (value: unknown): value is Locale =>
  typeof value === 'string' && (locales as readonly string[]).includes(value);

export const htmlLang: Record<Locale, string> = { kz: 'kk', ru: 'ru', en: 'en' };
